import { Flex } from '@/components/priority/Flex/Flex'
import { Text } from '@/components/priority/Text/Text'
import { useTranslation } from 'react-i18next'

export const PdfProofWrapperHeader = ({
  contentDimensions,
}: {
  contentDimensions: { width: number; height: number }
}) => {
  const { t } = useTranslation()

  // Calculate scale factor based on content dimensions
  // Use a base size for standard letter size (612x792) and scale from there
  const baseWidth = 612
  const scaleFactor = Math.max(
    0.8,
    Math.min(2.0, contentDimensions.width / baseWidth),
  )
  const scaledTextSize = Math.round(18 * scaleFactor * 1.2) // 20% larger

  return (
    <Flex height="0.8in" justify="center" align="center" column={true}>
      <Text size={`${scaledTextSize}px`} weight="bold" color="black">
        {t('pdf.productionProof')}
      </Text>
    </Flex>
  )
}
